import React from 'react'
import styled from 'styled-components'

export const StatusRow = () => {
  return (
    <Wrapper>
      <WrapperStatus>
        <StatusText>Approval Status</StatusText>
        <Divider />
        <Circle color='#5CB85C' />
        <StatusText>Approved</StatusText>
        <Circle color='#F0AD4E' />
        <StatusText>Pending</StatusText>
        <Circle color='#BBBBBB' />
        <StatusText>Unsubmitted</StatusText>
        <Circle color='#D44B49' />
        <StatusText>Rejected</StatusText>
      </WrapperStatus>
      <WrapperLegends>
        <StatusText>Legends</StatusText>
        <Divider />
        <Square color='#EBEBEB' />
        <StatusText>Sat - Sun</StatusText>
        <Square color='#7B7B7B' />
        <StatusText>Holiday</StatusText>
        <Square color='#222222' />
        <StatusText>Full day leave</StatusText>
        <Square color='#FBFF7A' />
        <StatusText>Half day leave</StatusText>
        <Square color='#0071BD' />
        <StatusText>Compensate work</StatusText>
      </WrapperLegends>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: #EEEEEE ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #CCCCCC;
  padding-left: 1%;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const WrapperStatus = styled.div`
  background-color: #EEEEEE ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  height: 40px;
  max-width: 40%;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #CCCCCC;
  padding-left: 1%;
`
const WrapperLegends = styled.div`
  background-color: #EEEEEE ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  height: 40px;
  max-width: 60%;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #CCCCCC;
  padding-left: 40px;
`
const StatusText = styled.div`
  font-family: 'Gotham' !important;
  font-size: 12px;
`
const Divider = styled.p`
  margin: 10px;
  border-left: 1px solid #BBBBBB;
  height: 50%;
`
const Circle = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 5px;
`
const Square = styled.div`
  height: 20px;
  width: 20px;
  background-color: ${(props) => props.color};
  margin-left: 10px;
  margin-right: 5px;
  border: 1px solid black;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/status-row.js